module.exports = new __parcel__URL__("Frame-8.935ea0f9.svg").toString();